import React from "react";
import Icon from "@ant-design/icons";


const LocationSvg = () => (
    <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 48 48">
        <path d="M24.42,4.15c-7.84,0-14.23,6.38-14.23,14.23,0,2.18.49,4.29,1.47,6.26,0,0,.26.53.32.63l11.38,18.62c.23.37.63.6,1.07.6s.84-.23,1.07-.6l11.39-18.65.3-.6c.97-1.98,1.46-4.08,1.46-6.26,0-7.85-6.38-14.23-14.23-14.23ZM34.93,23.54s0,0,0,0l-10.51,17.3-10.27-16.8-.25-.5c-.8-1.63-1.21-3.37-1.21-5.16,0-6.47,5.26-11.73,11.73-11.73s11.73,5.26,11.73,11.73c0,1.79-.41,3.53-1.21,5.16Z"/>
        <path d="M24.42,11.39c-3.9,0-7.07,3.17-7.07,7.07s3.17,7.07,7.07,7.07,7.07-3.17,7.07-7.07-3.17-7.07-7.07-7.07ZM24.42,23.02c-2.52,0-4.57-2.05-4.57-4.57s2.05-4.57,4.57-4.57,4.57,2.05,4.57,4.57-2.05,4.57-4.57,4.57Z"/>
    </svg>
);

const LocationIcon = (props) => (
    <Icon component={ LocationSvg } { ...props } />
);

export default LocationIcon;
